var _text, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlayNow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1984,
    height: 2397,
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    x: 521.861,
    y: 2174.731,
    stroke: "null",
    strokeWidth: 0,
    fontFamily: "'Catamaran',Fallback,sans-serif",
    fontSize: 200,
    fontWeight: "bold",
    transform: "matrix(1.48356 -.00248 .00213 1.27773 -447.838 -543.54)"
  }, "Play Now")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "null",
    d: "M559.083 554.677c15.286 0 30.572 3.447 44.468 10.34l901.865 432.008c40.299 19.532 44.467 50.554 44.467 63.192s-4.168 44.81-44.467 63.192L603.55 1555.417c-13.896 6.894-29.182 10.34-44.468 10.34-43.078 0-88.936-28.723-88.936-73.532V628.21c0-44.809 45.858-73.533 88.936-73.533m0-59.745c-84.767 0-162.586 56.298-162.586 134.427v864.014c0 78.129 77.819 134.427 162.586 134.427 26.403 0 54.195-5.744 80.598-18.383l901.865-432.007c107-51.703 107-180.385 0-230.94L639.68 513.316c-26.403-12.639-54.195-18.383-80.598-18.383z",
    className: "st0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayNow);
export default __webpack_public_path__ + "static/media/play-now.0730bc39e4922fe2c7aa254e2d3035ae.svg";
export { ForwardRef as ReactComponent };